import { useContext, useState } from "react"

//SOAR modules
import { UserContext } from "../../../../context/userContext"

//Referrals modules
import ReferralEntityForm from "./Form/ReferralEntityForm"

export default function ReferralEntityProfile() {
  const userCtx = useContext(UserContext)
  const [refresh, setRefresh] = useState(true)

  return (
    <ReferralEntityForm
      referralEntityId={-1}
      hideCancelButton={true}
      onEntityCreated={() => {
        userCtx.setNotificationInformation("Partner profile changes saved")
        setRefresh(!refresh)
      }}
      triggerRefresh={refresh}
    />
  )
}
